import { Component, Input, OnInit } from '@angular/core';
import { MasterService } from '../../../Services/master.service';
import { Utility } from '../../../Utilities/utility';
import { CookieService } from 'ngx-cookie-service';


@Component({
  selector: 'app-contact-view',
  templateUrl: './contact-view.component.html',
  styleUrls: ['./contact-view.component.css']
})
export class ContactViewComponent implements OnInit {
  @Input() RefId: number;
  @Input() CompanyId: number;
  contact:any;
  utility:Utility;
  constructor(
    private _MasterService:MasterService
    , private cookieService: CookieService
  ) { 
    this.RefId =0;
    this.CompanyId =0;
    this.utility = new Utility(this.cookieService);
  }

  ngOnInit(): void {
    if(this.RefId){
    this._MasterService.GetContactDetailByRefId(this.RefId).subscribe((d: any) => {
      this.contact = d;
    },(error) => {                              //Error callback
      this.utility.Error(error);
    });
  }
  }

}
